/******************************************************************************************************************************************************
 Revision History
 2024-07-15 TBH - Added dateOfBirth required to loginAssistanceForm. Fixed run on typo in peopleCode (was "People Codeis required.").
 2024-09-26 TBH - RFU (commented out) validator for required DOB with format validation.
 2024-10-31 TBH - Changed Date of birth required message from "Date of birth is required." to "Date of birth is required to reset forgotton password.".
 2025-05-13 TBH - Added validators for ABA survey on request for certificate page.
 ******************************************************************************************************************************************************/

import Zod from "zod";  // https://zod.dev/

function requiredString(error) {
  return Zod.string({
    required_error: error,
  }).min(1, { message: error });
}
const optionalString = Zod.string();

const checkboxes = requiredString( "Please select at least one option." );
const city = requiredString( "City is required." );
const company = requiredString( "Company is required." );
const consent = requiredString( "Consent is required." );
const eventName = requiredString( "Event name is required." );
const lastName = requiredString( "Last name is required." );
const firstName = requiredString( "First name is required." );
const dateOfBirth = requiredString( "Date of birth is required to reset forgotten password." ); 

/* 2024-09-26 TBH - RFU (commented out) validator for required DOB with format validation.
const dateOfBirth = Zod.string({
  required_error: "Date of birth is required."
}).regex(/^(0[1-9]|1[12])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/$, "Please enter date in month/day/year format (mm/dd/yyyy)" )
*/
const create_firstName = Zod.string({
    required_error: "First name is required.",
})
    .min(2, { message: "First name must have at least 2 characters." })
    .regex(/^[a-z A-Z]+$/, "Only alphabetic characters are permitted in the name fields when creating an account. Please enter your name using only letters.")
const create_lastName = Zod.string({
    required_error: "Last name is required.",
})
    .min(2, { message: "Last name must have at least 2 characters." })
    .regex(/^[a-z A-Z]+$/, "Only alphabetic characters are permitted in the name fields when creating an account. Please enter your name using only letters.")
const gender = requiredString("Gender is required.");

const message = requiredString("Message is required.");
const programName = requiredString("Program name is required.");
const state = requiredString("State is required.");
const zipCode = requiredString("Postal code is required.");
const cartType = requiredString("Card type is required.");
const cartNumber = requiredString("Card number is required.");
const streetAddress = requiredString("Street address is required.");
const expMonth = requiredString("Expiration month is required.");
const expYear = requiredString("Expiration year is required.");
const securityCode = requiredString("Security is required.");
const isInternationalAddress = requiredString("International (non-U.S.) credit card is required.");
const operatorId = requiredString("Operator Id is required");
const operatorPassword = requiredString("Operator password is required");

const peopleCode = requiredString("People Code is required");
const phonenumbers = requiredString("Atleast one preferred phone is required");

const countryOfCitizenship = requiredString(
  "Country of citizenship is required."
);
const countryOfBirth = requiredString("Country of birth is required.");
const email = Zod.string({
  required_error: "Email address is required.",
}).email({
  message: "Provide a valid email address.",
});
    
const password = Zod.string({
  required_error: "Password is required.",
})

  .min(8, { message: "Password must have at least 8 characters." })
  .max(18, { message: "Password must not exceed 18 characters." })
  .regex( /[A-Z]/g, "Password must contain at least one uppercase letter.")
  .regex( /[a-z]/g, "Password must contain at least one lowercase letter.")
  .regex( /^[A-z]/, "Password must begin with a letter.")
  .regex( /[A-z]$/, "Password must end with a letter.")
  .regex( /[\d@#$!]/, "Must contain a number or a special character (@, #, $, or !)."
  );
const phone = Zod.string({
  required_error: "Phone number is required.",
}).regex(/\(\d{3}\)\s\d{3}-\d{4}/, {
  message: "Provide a valid phone number.",
});
const phoneOptional = Zod.string()
  .regex(/\(\d{3}\)\s\d{3}-\d{4}/, {
    message: "Provide a valid phone number.",
  })
  .or(Zod.string().length(0));
const ssn4 = Zod.string({
  required_error: "Last four digits of your SSN are required.",
}).regex(/\d{4}/, { message: "Last four digits of your SSN are required." });
const zip = Zod.string({
  required_error: "A 5-digit zip is required.",
}).regex(/\d{5}/, { message: "A 5-digit zip is required." });

export default {
    feeSummaryForm : Zod.object({
        cardType: cartType,
        expirationMonth: expMonth,
        expirationYear: expYear,
        cardToken: cartNumber,
        isInternationalAddress: isInternationalAddress,
        name: Zod.string(),
        billAddress: Zod.string(),
        zipCode: Zod.string(),
    })
        .superRefine((values, ctx) => {
       
            if (values.isInternationalAddress == "false") {
                if (!values.name || values.name.length<=0) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        type: "string",
                        inclusive: true,
                        message: "Name Required",
                        path: ["name"],
                    });
                }
           
                if (!values.billAddress ||  values.billAddress.length <= 0) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        type: "string",
                        inclusive: true,
                        message: "Address Required",
                        path: ["billAddress"],
                    });
                }
                if (!values.zipCode || values.zipCode.length <= 0) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,

                        type: "string",
                        inclusive: true,
                        message: "ZipCode Required",
                        path: ["zipCode"],
                    }
                    );
                }
        } 
        

    }),
  contactForm: Zod.object({
    firstName: firstName,
    lastName: lastName,
    emailAddress: email,
    howToHelp: optionalString,
    inquiryChoice: checkboxes,
    otherText: Zod.string().optional(),
  }).superRefine((values, ctx) => {
    if (values.inquiryChoice.includes("Other")) {
      if (values.otherText === "") {
        ctx.addIssue({
          code: Zod.ZodIssueCode.too_small,
          minimum: 1,
          type: "string",
          inclusive: true,
          message: "Please specify other details",
          path: ["otherText"],
        });
      }
    }
  }),
    loginAssistanceForm: Zod.object({
      firstName: firstName,
      lastName: lastName,
      currentEmail: email,
      streetAddress: streetAddress,
      dateOfBirth: dateOfBirth,
      areYouInternationalStudent: checkboxes,
      areYouInstructor: checkboxes,
    }),
  corporateEducationContactForm: Zod.object({
    firstName: firstName,
    lastName: lastName,
    company: company,
    emailAddress: email,
    howToHelp: message,
  }),
  eventsRegistrationForm: Zod.object({
    eventName: eventName,
    firstName: firstName,
    lastName: lastName,
    emailAddress: email,
  }),
  forgotPasswordForm: Zod.object({
    dateOfBirth: dateOfBirth,
    email: email,
  }),
  loginForm: Zod.object({
    password: password,
    userName: email,
  }),
  lookupDCELoginEmailForm: Zod.object({
    firstName: firstName,
    lastName: lastName,
    birthDate: dateOfBirth,
  }),
   adminLoginForm: Zod.object({
       peopleCode: peopleCode,
       operatorId: operatorId,
       operatorPassword: operatorPassword
  
    }),
  mobileOptInForm: Zod.object({
    firstName: firstName,
    lastName: lastName,
    emailAddress: email,
    phoneNumber:phone,
    consent: consent,
  }),
  createAccountFormStep1: Zod.object({
    firstName: create_firstName,
    lastName: create_lastName,
    countryOfCitizenship: countryOfCitizenship,
    countryOfBirth: countryOfBirth,
    gender: gender,
    dateOfBirth: dateOfBirth,
    socialSecurityNumber: Zod.string(),
    confirmSocialSecurityNumber: Zod.string(),
    internationStudentNumber: Zod.string(),
    confirminternationStudentNumber: Zod.string(),
    middleName:Zod.string(),
  }).superRefine((values, ctx) => {
    if (
      values.countryOfCitizenship === "U.S.A." ||
      values.countryOfBirth === "U.S.A."
    ) {
        // SSN Required
        if (
            !values.socialSecurityNumber ||
            values.socialSecurityNumber.length < 9
        ) {
            ctx.addIssue({
                code: Zod.ZodIssueCode.too_small,
                minimum: 9,
                type: "string",
                inclusive: true,
                message: "Social security number is required.Please enter valid SSN.",
                path: ["socialSecurityNumber"],
            });
        } else if (!/^\d{3}-?\d{2}-?\d{4}$/.test(values.socialSecurityNumber)) {
            // SSN must contain 9 digits with optional formatting.
            ctx.addIssue({
                code: Zod.ZodIssueCode.custom,
                message: "Social security number must contain 9 digits.",
                path: ["socialSecurityNumber"],
            });
        } else if (!values.confirmSocialSecurityNumber) {
            // Confirm SSN required.
            ctx.addIssue({
                code: Zod.ZodIssueCode.too_small,
                minimum: 9,
                type: "string",
                inclusive: true,
                message: "Confirm social security number.",
                path: ["confirmSocialSecurityNumber"],
            });
        } else if (
            values.socialSecurityNumber !== values.confirmSocialSecurityNumber
        ) {
            ctx.addIssue({
                code: Zod.ZodIssueCode.custom,
                message: "Social security numbers don't match",
                path: ["confirmSocialSecurityNumber"],
            });
        }
    } else {
      // International Student Number required
     if (
        values.internationStudentNumber !==
        values.confirminternationStudentNumber
      ) {
        ctx.addIssue({
          code: Zod.ZodIssueCode.custom,
          message: "International student ID numbers don't match",
          path: ["confirminternationStudentNumber"],
        });
      }
      } if (values.middleName.length > 0) {
          if ((!/^[a-z A-Z]+$/.test(values.middleName))) {
              ctx.addIssue({
                  code: Zod.ZodIssueCode.custom,
                  minimum: 2,
                  type: "string",
                  inclusive: true,
                  message: "Only alphabetic characters are permitted in the name fields when creating an account. Please enter your name using only letters.",
                  path: ["middleName"],
              });
          } else if (values.middleName.length > 0 && values.middleName.length <2 ){
              ctx.addIssue({
                  code: Zod.ZodIssueCode.custom,
                  minimum: 2,
                  type: "string",
                  inclusive: true,
                  message: "Middle name must have at least 2 characters.",
                  path: ["middleName"],
              });
          }
        
      }
  }),
  createAccountFormStep2: Zod.object({
    emailAddress: email,
    confirmEmail: requiredString('Confirm email address.'),
    password: password,
    confirmPassword: requiredString('Confirm password.'),
  })
    .refine((schema) => schema.emailAddress === schema.confirmEmail, {
      message: "Email addresses don't match.",
      path: ["confirmEmail"],
    })
    .refine((schema) => schema.password === schema.confirmPassword, {
      message: "Passwords don't match.",
      path: ["confirmPassword"],
    }),
  notifyMeForm: Zod.object({
    programName: programName,
    firstName: firstName,
    emailAddress: email,
  }),
  requestAToolkitForm: Zod.object({
    currentPageName: programName,
    firstName: firstName,
    lastName: lastName,
    emailAddress: email,
    phoneNumber: phoneOptional,
  }),
  requestCatalogForm: Zod.object({
    firstName: firstName,
    lastName: lastName,
    emailAddress: email,
    streetAddress: streetAddress,
    city: city,
    state: state,
    zip: zip,
    phoneNumber: phone,
  }),
  requestInfoForm: Zod.object({
    currentPageName: programName,
    firstName: firstName,
    lastName: lastName,
    emailAddress: email,
    phoneNumber: phoneOptional,
  }),
  resetPasswordForm: Zod.object({
    password: password,
    confirmPassword: password,
  }).refine((schema) => schema.password === schema.confirmPassword, {
    message: "Passwords don't match.",
    path: ["confirmPassword"],
  }),
  uploadDocumentForm: Zod.object({
    peopleCodeId: requiredString("ID of the user uploading is required."),
    flContent: Zod.any()
      .refine(
        (file) => file instanceof File,
        "Not File: Please select a file to upload."
      )
      .refine(
        (file) => file?.name && file?.size,
        "File name/size: Please select a file to upload."
      )
      .refine(
        (file) => file?.size <= 4 * 1024 * 1024,
        "File cannot exceed limit of 4MB."
      )
      .refine(
        (file) =>
          [
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "image/gif",
            "image/jpeg",
            "image/jpg",
            "application/pdf",
          ].includes(file?.type),
        "Please upload a valid file type (doc, docx, gif, jpg, jpeg, pdf)."
      ),
    officeCode: requiredString("Office is required."),
    DocumentTypeCode: requiredString("Document type is required."),
    Notes: requiredString("Comment is required.").max(500, {
      message: "Password must not exceed 500 characters.",
    }),
  }),

  requestCertificateForm2: Zod.object({
    curriculum: requiredString( "Certificate program is required." ),

    abaSurvey: Zod.string(),
    educationSchoolName: Zod.string(),
    educationDegreeCert: Zod.string(),
    employmentCompany: Zod.string(),
    employmentCity: Zod.string(), 
    employmentStateRegion: Zod.string(),

    notifyEmployer: Zod.string().optional(),
    supervisorEmail: Zod.string(),
    supervisorName: Zod.string(),
    company: Zod.string(),

  }).superRefine(( values, ctx ) => {
    if( values.curriculum ) {
      if(( values.curriculum == 'PARAL' )||( values.curriculum == 'PARALC' )) {
        if( !values.abaSurvey ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "ABA survey response is required.",
            path: ["abaSurvey"],
          });
        }
      }
    }
  }).superRefine(( values, ctx ) => {
    if( values.abaSurvey ) {
      if( values.abaSurvey == 'CE' ) {
        if( !values.educationSchoolName ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter name of school you'll be attending.",
            path: ["educationSchoolName"],
          });
        }
        if( !values.educationDegreeCert ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter degree or certificate you'll be studying.",
            path: ["educationDegreeCert"],
          });
        }
      } else if(( values.abaSurvey == 'WP' )||( values.abaSurvey == 'WAC' )||( values.abaSurvey == 'WAF' )) {
        if( !values.employmentCompany ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter company.",
            path: ["employmentCompany"],
          });
        }
        if( !values.employmentCity ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter city.",
            path: ["employmentCity"],
          });
        }
        if( !values.employmentStateRegion ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter state or region.",
            path: ["employmentStateRegion"],
          });
        }
      }
    }
  }).superRefine(( values, ctx ) => {
    if( values.notifyEmployer ) {
      if( values.notifyEmployer == "on" ) {
        if( !values.supervisorEmail ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter supervisor email.",
            path: ["supervisorEmail"],
          });
        }
        if( !values.supervisorName ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter supervisor name.",
            path: ["supervisorName"],
          });
        }
        if( !values.company ) {
          ctx.addIssue({
            code: Zod.ZodIssueCode.too_small,
            minimum: 1,
            type: "string",
            inclusive: true,
            message: "Please enter company.",
            path: ["company"],
          });
        }
      }
    }
  }),

    changeEmailLoginRequestForm: Zod.object({
        firstName: firstName,
        lastName: lastName,
        birthDate: dateOfBirth,
        currentEmail: email,
    }),

    replaceEmailForm: Zod.object({
        
        newEmailAddress: email,
        confirmEmail:email,
    }).refine((schema) => schema.newEmailAddress === schema.confirmEmail, {
        message: "Email addresses do not match.",
        path: ["confirmEmail"],
    }), 
    updatePhoneNumbers: Zod.object({
        PrimaryPhone: requiredString("Primary phone is required."),
        CellCountryId: Zod.string(),
        CellPhoneUSA: Zod.string(),
        CellPhone: Zod.string(),
        HomeCountryId: Zod.string(),
        HomePhoneUSA: Zod.string(),
        HomePhone: Zod.string(),
        WorkCountryId: Zod.string(),
        WorkPhoneUSA: Zod.string(),
        WorkPhone: Zod.string(),
    }).superRefine((values, ctx) => {
        if (values.PrimaryPhone) {
            if (values.PrimaryPhone === "CELL") {
                if (values.CellCountryId==="0") {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please select country.",
                        path: ["CellCountryId"],
                    });
                }
                if (values.CellCountryId == "261" && !values.CellPhoneUSA) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please enter phone number.",
                        path: ["CellPhoneUSA"],
                    });
                } 
                if (values.CellCountryId != "261" && !values.CellPhone) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please enter phone number.",
                        path: ["CellPhone"],
                    });
                } 
            }
            if (values.PrimaryPhone === "HOME") {
                if (values.HomeCountryId === "0") {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please select country.",
                        path: ["HomeCountryId"],
                    });
                }
                if (values.HomeCountryId == "261" && !values.HomePhoneUSA) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please enter phone number.",
                        path: ["HomePhoneUSA"],
                    });
                } 
                if (values.HomeCountryId != "261" && !values.HomePhone) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please enter phone number.",
                        path: ["HomePhone"],
                    });
                } 
            }
            if (values.PrimaryPhone === "WORK") {
                if (values.WorkCountryId === "0") {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.invalid_enum_value,
                       
                        message: "Please select country.",
                        path: ["WorkCountryId"],
                    });
                }
                if (values.WorkCountryId == "261" && !values.WorkPhoneUSA) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please enter phone number.",
                        path: ["WorkPhoneUSA"],
                    });
                } 
                if (values.WorkCountryId != "261" && !values.WorkPhone) {
                    ctx.addIssue({
                        code: Zod.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "Please enter phone number.",
                        path: ["WorkPhone"],
                    });
                } 
            }
            if (values.CellCountryId == "261" && values.CellPhoneUSA && !/^\(\d{3}\) \d{3}-\d{4}$/.test(values.CellPhoneUSA)) {
                ctx.addIssue({
                    code: Zod.ZodIssueCode.invalid_string,
                    type: "string",
                    message: "Invalid phone number format.",
                    path: ["CellPhoneUSA"],
                });
            }
            if (values.CellCountryId != "261" && values.CellPhone && !/^\d+$/.test(values.CellPhone)) {
                ctx.addIssue({
                    code: Zod.ZodIssueCode.invalid_string,
                    type: "string",
                    message: "Phone number should contain only numbers.",
                    path: ["CellPhone"],
                });
            }
            if (values.HomeCountryId == "261" && values.HomePhoneUSA && !/^\(\d{3}\) \d{3}-\d{4}$/.test(values.HomePhoneUSA)) {
                ctx.addIssue({
                    code: Zod.ZodIssueCode.invalid_string,
                    type: "string",
                    message: "Invalid phone number format.",
                    path: ["HomePhoneUSA"],
                });
            }
            if (values.HomeCountryId != "261" && values.HomePhone && !/^\d+$/.test(values.HomePhone)) {
                ctx.addIssue({
                    code: Zod.ZodIssueCode.invalid_string,
                    type: "string",
                    message: "Phone number should contain only numbers.",
                    path: ["HomePhone"],
                });
            }
            if (values.WorkCountryId == "261" && values.WorkPhoneUSA && !/^\(\d{3}\) \d{3}-\d{4}$/.test(values.WorkPhoneUSA)) {
                ctx.addIssue({
                    code: Zod.ZodIssueCode.invalid_string,
                    type: "string",
                    message: "Invalid phone number format.",
                    path: ["WorkPhoneUSA"],
                });
            }
            if (values.WorkCountryId != "261" && values.WorkPhone && !/^\d+$/.test(values.WorkPhone)) {
                ctx.addIssue({
                    code: Zod.ZodIssueCode.invalid_string,
                    type: "string",
                    message: "Phone number should contain only numbers.",
                    path: ["WorkPhone"],
                });
            }
        }
    }),
    
};
